import { omdApi } from '../../api';
import { ProfileInfo } from '../types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getProfileInfo: builder.query<ProfileInfo, void>({
      query: () => ({
        url: '/v1/profile',
      }),
    }),
  }),
});

export const { useGetProfileInfoQuery, useLazyGetProfileInfoQuery } = request;
